var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-overlay',{attrs:{"value":_vm.getShowLoading,"opacity":_vm.bgOpacity,"z-index":"2000"}},[_c('div',[_c('LogoAnimation',{staticClass:"logo-animation"}),_c('p',{staticClass:"mt-5"},[_vm._v(_vm._s(_vm.message))])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }